// extracted by mini-css-extract-plugin
export default {"reservation_source":"reservationSource_reservation_source__EFzZz","text":"reservationSource_text__k203Q"};